import { ActionCardData, checkVisibility, matchElementRange, ViewMode } from '@playbooks/action-cards-utils/src'
import makeSeparatorScopes from './makeSeparatorScopes'
import getSlides from './getSlides'

export default function getSectionsSet({
  actionCards,
  headersCount,
  hideSeparatorsAbility,
  viewMode,
}: {
  actionCards: ActionCardData
  headersCount?: number | null
  hideSeparatorsAbility?: boolean
  viewMode?: ViewMode
}) {
  const sections = actionCards.sections.filter(section => {
    return checkVisibility(section, actionCards) && matchElementRange(section, actionCards)
  })

  const { scopes, visiblePinnedSections } = makeSeparatorScopes({
    sections,
    conditionalItems: actionCards.conditionalItems || [],
    displayHeadersCount: headersCount,
    hideSeparatorsAbility: hideSeparatorsAbility,
    isFunnelView: viewMode === ViewMode.FUNNEL,
  })

  return { scopes, visiblePinnedSections, slides: getSlides(scopes) }
}
